
class CurrencyFormatter {
    private numberFormatter: Intl.NumberFormat;

    constructor(culture: string, currency: string) {
        this.numberFormatter = new Intl.NumberFormat(culture, {
            style: 'currency',
            currency
        })
    }

    public format(value: number): string {
        return this.numberFormatter.format(value);
    }
}

const AudCurrencyFormatter = new CurrencyFormatter('en-AU', 'AUD');

export default AudCurrencyFormatter;


// WEBPACK FOOTER //
// ./src/utilities/currencyFormatter.ts